<template>
    <v-dialog v-model="value" max-width="980" persistent scrollable >
        <v-card>
            <v-toolbar flat>
                {{ title }}
                <v-spacer></v-spacer>
                <v-btn icon @click="close()"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>

            <v-card-text class="html-editor-dialog">
                <HtmlContentEditor v-model="curContent" :showInModalBtn="false" />
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
/* eslint-disable */

export default {
    name: 'HtmlEditorDialog',
    props: ['value', 'content', 'title'],
    components: {
        HtmlContentEditor: () => import('./HtmlContentEditor.vue'),
    },
    watch: {
        value(v) {
            if (v)
                this.curContent = this.content
        }
    },
    data() {
        return {
            curContent: ''
        }
    },
    
    methods: {
        close() {
            this.$emit('ok', this.curContent)
            this.$emit('input', false)
        }
    }
}

</script>

<style>

.html-editor-dialog .ProseMirror {
    height: 400px;
}

</style>
